export const STEP_KINDS = [
  {
    value: "INFORM",
    label: "Informar",
    description:
      "O agente envia a mensagem do texto base, preservando o tom e o conteúdo deste step.",
  },
  {
    value: "ASK",
    label: "Aguardar resposta",
    description:
      "O agente não envia mensagem; aguarda a resposta do lead para avaliar a intenção e seguir o fluxo.",
  },
  {
    value: "CONFIRM",
    label: "Confirmar",
    description:
      "O agente pede confirmação de uma informação já coletada antes de prosseguir.",
  },
  {
    value: "SCHEDULE",
    label: "Agendar",
    description:
      "Reserva automaticamente o horário escolhido na agenda do trader.",
  },
  {
    value: "HANDOFF",
    label: "Transferir (handoff)",
    description:
      "Encerra a automação e encaminha o lead para atendimento humano.",
  },
];

export function getStepKindInfo(kind) {
  return (
    STEP_KINDS.find((k) => k.value === kind) ?? {
      value: kind,
      label: kind,
      description: "",
    }
  );
}
